import { observable } from 'mobx';
import { IRootStore } from '@stores/index';

type Status = 'pending' | undefined;
export type UserRole = 'member' | 'read-write' | 'admin';

type Member = {
  id: string;
  name: string;
  email: string;
  status?: Status;
  role: UserRole;
  invitedAt?: string;
};

export interface IMemberStore extends Member {
  rootStore: IRootStore;
}

export class MemberStore implements IMemberStore {
  @observable public id = '';

  @observable public name = '';

  @observable public email = '';

  @observable public role = 'member' as UserRole;

  @observable public status: Status;

  @observable public invitedAt? = '';

  @observable public rootStore: IRootStore;

  constructor({ id, name, email, status, role, invitedAt }: Member, rootStore: IRootStore) {
    this.id = id;
    this.name = name;
    this.email = email;
    if (status) {
      this.status = status;
    }
    this.role = role;
    this.invitedAt = invitedAt;
    this.rootStore = rootStore;
  }
}
